module.exports = __webpack_public_path__ + "static/img/downimg.85636d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home_model/downimg.png
// module id = ZJZn
// module chunks = 80